export const FILE_TYPES = {
  pdf: { label: 'PDF', badgeVariant: 'soft', badgeColor: 'red' },
  pptx: { label: 'PPTX', badgeVariant: 'soft', badgeColor: 'orange' },
  docx: { label: 'DOCX', badgeVariant: 'soft', badgeColor: 'blue' },
  xlsx: { label: 'XLSX', badgeVariant: 'soft', badgeColor: 'green' },
};

export const getFileType = (url, name) => {
  const source = url || name || '';
  const ext = source.split('?')[0].split('#')[0].split('.').pop()?.toLowerCase();
  return ext || 'unknown';
};

export const formatDate = (iso) => {
  if (!iso) { return ''; }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) { return ''; }
  return d.toLocaleDateString('en-GB');
};

export const normalizeDocument = (doc) => ({
  id: doc.id,
  name: doc.name,
  url: doc.url,
  size: doc.size,
  type: getFileType(doc.url, doc.name),
  updatedAt: formatDate(doc.updatedAt),
  updatedAtRaw: doc.updatedAt,
});
